import AxiosGlobalInstance, { AxiosPromise, IConsorcieiResponse } from '@/services/index';

/**
 * List all the adms
 * @param admHash hash for adm slug
 * @return Return promise with axios response
 */
export function listAdms(admHash?: string): AxiosPromise<IConsorcieiResponse<Record<string, unknown>>> {
  return AxiosGlobalInstance.get(`/adm/list/${admHash}`);
}
